import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "tick",
  "use": "tick-usage",
  "viewBox": "0 0 21 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 21 16\" id=\"tick\">\r\n  <polygon points=\"7.73 9.92 3.11 5.41 0 8.45 7.73 16 21 3.04 17.89 0 7.73 9.92\" />\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol